import React, { useEffect, useRef, useState } from 'react';
import { TabPane, Form, Grid, Button } from 'semantic-ui-react';
import Components from '../../../app/common/components'; 
import { useStore } from '../../../app/stores/store';
import { isArray } from 'lodash';

interface HFCMetadataProps {
  formValues: {
    title: string;
    elementType: string;
    assetType: string;
    assetId: string;
    print: string;
  };
  goToNextTab: () => void;
  metaData: any[]; 
  updateMetaData: (updatedMetaData: any[]) => void; 
}

const HFCMetadata: React.FC<HFCMetadataProps> = ({formValues,  metaData, updateMetaData, goToNextTab}) => {
  const [isNextDisabled, setIsNextDisabled] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const{commonStore} = useStore()
  const mandatoryFieldsRef = useRef<any>({});


  useEffect(() => {
    const updatedMetaData = metaData.map(item => {
      if (item.elementName === "Title") {
        return { ...item, elementValue:  formValues.title};
      }
      return item;
    });
    updateMetaData(updatedMetaData);
    const hasEmptyMandatoryValue = updatedMetaData.some((meta: { isMandatory: any; elementValue: string | undefined; }) => meta.isMandatory && (meta.elementValue === undefined || meta.elementValue === ''));
    setIsNextDisabled(hasEmptyMandatoryValue);
    // eslint-disable-next-line
  }, []);

  const collectSelectValue=(e:any, data:any, copyMetadataDetails:any)=>{
    let copy: any = [...copyMetadataDetails];
    function updateElementHandler() {
      for (let i = 0; i < copy?.length; i++) {
        if (copy[i].elementId === data.id) {
          let value = '';
          if (isArray(data.value)) {
            value = data.value.join('|');
          } else {
            value = data.value;
          }
          copy[i].elementValue = value;
        }
        for (let j = 0; j < copy[i]?.options?.length; j++) {
          let linkID = '';
          if (data.value?.includes(copy[i]?.options?.[j]?.optionName)) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
          let newLinkId = linkID?.split('|');
          for (let x = 0; x < newLinkId?.length; x++) {
            let foundIndex = copy.findIndex(
              (localData: { templateElementId: string }) => {
                return newLinkId[x] === localData.templateElementId;
              },
            );
            if (copy?.[foundIndex] !== undefined) {
              if (
                copy?.[foundIndex].isMandatory &&
                copy?.[foundIndex]?.elementValue?.length === 0
              ) {
                mandatoryFieldsRef.current[`${copy?.[foundIndex].elementId}`] =
                  copy?.[foundIndex].elementId;
              }
              copy[foundIndex].enableByDefault = true;
            }
          }
        }
      }
      updateMetaData(copy)
    }
    updateElementHandler()
  }

const collectSelectInpVal = (e: any, data: any, validationData?: any) => {
  let copyMetadataDetails: any[] = [...metaData];

  let indexOfData = copyMetadataDetails.findIndex(
    (localData: { templateElementId: string }) =>
      localData.templateElementId === validationData.templateElementId
  );

  let errorTemp = { ...errorMessage }; 
  let result = '';
  let value =
    /datepicker/gi.test(validationData?.elementType || '') ?
    e?.toLocaleDateString('en-IN', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    }) :
    validationData?.elementType === 'DateTime' ?
    new Date(data).toDateString() +
    ' ' +
    new Date(data).toString().split(' ')[4] :
    data.value;

  let payload = {
    ...validationData,
    elementValue: value,
  };

  if (indexOfData < 0) {
    copyMetadataDetails.push(payload); 
  } else {
    copyMetadataDetails[indexOfData] = payload; 
  }

  if (/textbox/gi.test(validationData?.elementType || '')) {
    result = commonStore.genericValidation(
      value || '',
      validationData?.validation || ''
    );
  }
  if (/dropdown/gi.test(validationData?.elementType || '')) {
    collectSelectValue(e, data, copyMetadataDetails);
  }

  if (validationData.isMandatory && !value?.length) {
    result = 'This is mandatory field';
  }

  if (result) {
    errorTemp[`${validationData?.elementId}`] = result;
    mandatoryFieldsRef.current[`${validationData?.elementId}`] =
      validationData?.elementId;
  } else {
    delete errorTemp[`${validationData?.elementId}`];
    delete mandatoryFieldsRef.current[`${validationData?.elementId}`];
  }
  
  setErrorMessage(errorTemp);
  const hasEmptyMandatoryValue = copyMetadataDetails.some((meta: { isMandatory: any; elementValue: string | undefined; }) => meta.isMandatory && (meta.elementValue === undefined || meta.elementValue === ''));
  setIsNextDisabled(hasEmptyMandatoryValue);
  updateMetaData(copyMetadataDetails)
};

  
  return (
    <TabPane style={{ height: "350px", overflowY: "auto" }}> 
      <Form>
      <Grid stretched columns={3}>
        {metaData.map((meta:any, index:number) => (
            <Grid.Column>
              <Components
                disabled={false}
                index={index}
                elementDetails={meta}
                onChangeHandler={collectSelectInpVal}
                onPhotoClick={()=>{}}
                getUploadedFiles={() => {}}
                onConfirmUser={() => {}}
              />
          </Grid.Column>
        ))}
        </Grid> 
        <div style={{textAlign: 'right', marginTop:'20px'}}>
              <Button primary onClick={goToNextTab} disabled={isNextDisabled}>Next</Button>
          </div>
      </Form>
    </TabPane>
  );
}

export default HFCMetadata;
